export default function intersectionArrayUtil (...arrays) {
  if (arrays.length === 0) {
    return []
  }

  const result = arrays[0].filter(item => {
    return arrays.every(array => array.includes(item))
  })

  return Array.from(new Set(result))
}
